import React from 'react';
import { useStyles } from './_utility';
import { useStore } from '../../zustand';
import tipsIcon from '../../assets/icons/tipsIcon.png';
import doubleTap from '../../assets/icons/doubleTap.png';
import adjustIcon from '../../assets/icons/adjust.png';
import rotateIcon from '../../assets/icons/rotate.png';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MobilePrompt = () => {
    // const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const classes = useStyles(dynamic_text_settings);
    const [open, setOpen] = React.useState(true);
    const actions = useStore(state => state.actions);

    const handleClose = e => {
        setOpen(false)
        setTimeout(() => {
            actions.handleModalDisplay({ display: '', status: false })
        }, 750)
    };

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="dispay-prompt"
            aria-describedby="dispay-prompt-modal"
            open={open}
            className={classes.root}
            TransitionComponent={Transition}
        >
            <section className={classes.modalClose}>
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </section>
            <section className={classes.modalTitle}>
                <h6>Helpful AR Viewing Hints</h6>
            </section>
            <MuiDialogContent dividers className={classes.root}>
                <section className={classes.promptBody}>
                <div className={classes.promptTips}>
                    <section className={classes.promptRow}>
                    <section className={classes.promptIcon}>
                        <img src={tipsIcon} alt="Double Tap Device" />
                    </section>
                    <section className={classes.promptCopy}>
                        <h5>Placing Image</h5>
                        <p>Point your phone at a flat surface in a well lit room or space. Move your phone slowly, if the model does not appear.</p>
                    </section>
                    </section>
                    <section className={classes.promptRow}>
                    <section className={classes.promptIcon}>
                        <img src={rotateIcon} alt="Double Tap Device" />
                    </section>
                    <section className={classes.promptCopy}>
                        <h5>Rotate Image</h5>
                        <p>Move your finger across the screen to rotate AR image</p>
                    </section>
                    </section>
                    <section className={classes.promptRow}>
                    <section className={classes.promptIcon}>
                        <img src={adjustIcon} alt="Adjust Scale" />
                    </section>
                    <section className={classes.promptCopy}>
                        <h5>Adjust Scale</h5>
                        <p>Place two fingers on the screen and move them towards or away from each other to zoom</p>
                    </section>
                    </section>
                    <section className={classes.promptRow}>
                    <section className={classes.promptIcon}>
                        <img src={doubleTap} alt="Double Tap Device" />
                    </section>
                    <section className={classes.promptCopy}>
                        <h5>Reset</h5>
                        <p>Touching the screen two times will reset the location of the AR image</p>
                    </section>
                    </section>
                </div>
                </section>
            </MuiDialogContent>
        </Dialog>
    );
}

export default MobilePrompt;
